var _foreignObject, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 73h204v204H73z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.5 62.5c-61.856 0-112 50.144-112 112s50.144 112 112 112 112-50.144 112-112-50.144-112-112-112m0 171.5c-32.861 0-59.5-26.639-59.5-59.5s26.639-59.5 59.5-59.5 59.5 26.639 59.5 59.5-26.639 59.5-59.5 59.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5 72.5c-56.333 0-102 45.667-102 102s45.667 102 102 102 102-45.667 102-102-45.667-102-102-102m0 171.5c-38.384 0-69.5-31.116-69.5-69.5s31.116-69.5 69.5-69.5 69.5 31.116 69.5 69.5-31.116 69.5-69.5 69.5",
    style: {
      fill: "#708090"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.211 148.01h260v52.5h-260z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.711 153.26h249v42h-249z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.711 174.26h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClash);
export default __webpack_public_path__ + "static/media/clash.cdae8192eab81dcf37e14414c9c7f7a1.svg";
export { ForwardRef as ReactComponent };